class RechargeWidget extends HTMLElement {
  constructor() {
    super();
    this.rechargeSelectFrequency = null
    this.targetForm = document.querySelector(`#${this.dataset.formId}`)
    this.inputSellingPlan = this.targetForm.querySelector(`input[name="selling_plan"]`)

    const rechargeConfig = {
      productId: this.dataset.productId, // Required
      injectionParent: this, // The node that will have the widget injected in
    };

    const interval =  window.setInterval(() => {
      if (window.ReChargeWidget) {
        clearInterval(interval);

        window.ReChargeWidget.createWidget(rechargeConfig)

        // for getting the selling plan select value and its change event
        const sellingPlanInterval = setInterval(() => {
          if (this.rechargeSelectFrequency && this.inputSellingPlan) {
            clearInterval(sellingPlanInterval);

            // set the default value of selling plan select
            this.inputSellingPlan.value = this.rechargeSelectFrequency.value
            // listen to the change event of selling plan select
            this.rechargeSelectFrequency.addEventListener('change', (event) => {
              this.inputSellingPlan.value = event.target.value
              console.log('this.inputSellingPlan', this.inputSellingPlan)
            });
          } else {
            this.rechargeSelectFrequency = this.querySelector(`select[name="selling_plan"]`);
            this.inputSellingPlan = this.targetForm.querySelector(`input[name="selling_plan"]`)
          }
        }, 100);
      }
    }, 300);
  }

}

customElements.define('recharge-widget', RechargeWidget);